import React, { Component } from "react";

import { Select } from "@rocketseat/unform";
import MaskedField from "../../../../components/MaskedField";

import placaMask from "../../../../components/Masks/Placa";

export default class Amarelo extends Component {
  /**
   * Componente para informar a placa do terceiro no formulário
   */
  state = {
    hidden: true
  };

  handleChange = event => {
    const { value } = event.target;

    if (value == 1) {
      this.setState({
        hidden: false
      });
    } else
      this.setState({
        hidden: true
      });
  };

  render() {
    return (
      <div className="d-flex">
        <label className="big">Placa do 3º:</label>
        <div className="d-flex" style={{ width: "100%" }}>
          <div className="filtro__input_container">
            <Select
              className="ant-input"
              options={[
                { id: 0, title: "Selecione" },
                { id: 1, title: "INFORMAR PLACA" },
                { id: 2, title: "NÃO POSSUI PLACA" }
              ]}
              name="possui_placa"
              onChange={this.handleChange}
            />
          </div>
          &nbsp;
          {this.state.hidden ? (
            ""
          ) : (
            <div className="filtro__input_container">
              <MaskedField
                name="placa"
                mask={placaMask}
                className="ant-input"
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Amarelo/Placa.js